/**
 * @generated SignedSource<<8d7ad4e4385d4d595e55ce828b59071d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Colors = "BLUE" | "GREEN" | "NO_COLOR" | "ORANGE" | "PURPLE" | "RED" | "YELLOW";
export type HomePanelGroupType = "MEETINGS" | "ONE_ON_ONE" | "OTHER_STREAMS" | "REGULAR" | "TEAMS";
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
export type HomeQuery$variables = {};
export type HomeQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly allowExternalInviting: boolean | null;
      readonly allowInviting: boolean | null;
      readonly billingAccount: {
        readonly hasAccessToTeams: boolean;
      };
      readonly guestUsersAllowInvite: boolean;
    };
    readonly homePanelGroups: ReadonlyArray<{
      readonly __typename: "HomePanelGroup";
      readonly emojiName: string | null;
      readonly id: string;
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly __typename: "NoteStream";
            readonly archived: boolean | null;
            readonly id: string;
            readonly otherUser: {
              readonly email: string;
              readonly id: string;
            } | null;
            readonly starred: boolean;
            readonly type: NoteStreamType;
            readonly " $fragmentSpreads": FragmentRefs<"StreamLink_stream">;
          } | {
            readonly __typename: "Tag";
            readonly __typename: "Tag";
            readonly color: Colors;
            readonly id: string;
            readonly label: string;
          } | {
            readonly __typename: "User";
            readonly email: string;
            readonly id: string;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null;
        } | null>;
      };
      readonly name: string;
      readonly order: number;
      readonly type: HomePanelGroupType;
      readonly " $fragmentSpreads": FragmentRefs<"HomePanelGroup_group">;
    } | null> | null;
    readonly id: string;
    readonly myTeams: ReadonlyArray<{
      readonly archived: boolean;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"TeamLink_info">;
    }> | null;
    readonly unreadBeacons: ReadonlyArray<string>;
    readonly user: {
      readonly email: string;
      readonly id: string;
      readonly internalAttributes: {
        readonly isAccountAdmin: boolean;
        readonly isManager: boolean;
      } | null;
      readonly isGuest: boolean;
    };
    readonly " $fragmentSpreads": FragmentRefs<"BillingIdentityFeaturesPaywall_viewer" | "HomePanelGroupsMenu_viewer">;
  };
};
export type HomeQuery = {
  response: HomeQuery$data;
  variables: HomeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unreadBeacons",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isManager",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAccountAdmin",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowInviting",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guestUsersAllowInvite",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowExternalInviting",
  "storageKey": null
},
v9 = {
  "alias": "hasAccessToTeams",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "teams"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"teams\")"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archived",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emojiName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "order",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "starred",
  "storageKey": null
},
v17 = [
  (v0/*: any*/),
  (v2/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v20 = [
  (v0/*: any*/)
],
v21 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "image",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isActive",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isConfigured",
    "storageKey": null
  },
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasReceivedInvites",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "relationshipToViewer",
    "storageKey": null
  },
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isTopUser",
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "onlyReportManager",
        "value": true
      }
    ],
    "concreteType": "Event",
    "kind": "LinkedField",
    "name": "activeRecurring1on1Event",
    "plural": false,
    "selections": (v20/*: any*/),
    "storageKey": "activeRecurring1on1Event(onlyReportManager:true)"
  }
],
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "HomePanelGroup",
  "kind": "LinkedField",
  "name": "homePanelGroup",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guid",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willBeRecorded",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAllDay",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeBlockType",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "ConferenceCall",
  "kind": "LinkedField",
  "name": "conferenceCalls",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "provider",
      "storageKey": null
    },
    (v22/*: any*/)
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "Calendar",
  "kind": "LinkedField",
  "name": "calendar",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v32 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "HomePanelGroup",
      "kind": "LinkedField",
      "name": "homePanelGroup",
      "plural": false,
      "selections": [
        (v13/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "HomePanelObjectInterface",
  "abstractKey": "__isHomePanelObjectInterface"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HomeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInternalAttributes",
                "kind": "LinkedField",
                "name": "internalAttributes",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "myTeams",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v10/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamLink_info"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HomePanelGroup",
            "kind": "LinkedField",
            "name": "homePanelGroups",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "HomePanelObjectsConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HomePanelObjectsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "StreamLink_stream"
                              },
                              (v0/*: any*/),
                              (v10/*: any*/),
                              (v16/*: any*/),
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "otherUser",
                                "plural": false,
                                "selections": (v17/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "NoteStream",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v0/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/)
                            ],
                            "type": "Tag",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v17/*: any*/),
                            "type": "User",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "HomePanelGroup_group"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BillingIdentityFeaturesPaywall_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HomePanelGroupsMenu_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "HomeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "featureAccess",
                    "storageKey": null
                  },
                  (v0/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v0/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HomePanelGroup",
            "kind": "LinkedField",
            "name": "homePanelGroups",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v13/*: any*/),
              (v12/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "HomePanelObjectsConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HomePanelObjectsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "User",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v0/*: any*/),
                              (v12/*: any*/),
                              (v22/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "userCount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerLastSeenAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "latestNoteEditedAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isExternal",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasExternalUsers",
                                "storageKey": null
                              },
                              (v23/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "otherUser",
                                "plural": false,
                                "selections": (v21/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Event",
                                "kind": "LinkedField",
                                "name": "linkedEvent",
                                "plural": false,
                                "selections": [
                                  (v0/*: any*/),
                                  (v24/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Event",
                                    "kind": "LinkedField",
                                    "name": "nextOccurrence",
                                    "plural": false,
                                    "selections": [
                                      (v25/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "end",
                                        "storageKey": null
                                      },
                                      (v0/*: any*/),
                                      (v24/*: any*/),
                                      (v26/*: any*/),
                                      (v27/*: any*/),
                                      (v28/*: any*/),
                                      (v29/*: any*/),
                                      (v30/*: any*/),
                                      (v31/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "finalOccurrence",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Note",
                                "kind": "LinkedField",
                                "name": "latestNote",
                                "plural": false,
                                "selections": [
                                  (v0/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "eventStart",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "eventEnd",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "finished",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Event",
                                    "kind": "LinkedField",
                                    "name": "event",
                                    "plural": false,
                                    "selections": [
                                      (v0/*: any*/),
                                      (v24/*: any*/),
                                      (v26/*: any*/),
                                      (v25/*: any*/),
                                      (v27/*: any*/),
                                      (v28/*: any*/),
                                      (v29/*: any*/),
                                      (v30/*: any*/),
                                      (v31/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NoteStreamPublicLink",
                                "kind": "LinkedField",
                                "name": "publicLink",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "enabled",
                                    "storageKey": null
                                  },
                                  (v0/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v10/*: any*/),
                              (v16/*: any*/),
                              (v32/*: any*/)
                            ],
                            "type": "NoteStream",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v0/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v23/*: any*/),
                              (v32/*: any*/)
                            ],
                            "type": "Tag",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v20/*: any*/),
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v11/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInternalAttributes",
                "kind": "LinkedField",
                "name": "internalAttributes",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "myTeams",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              (v22/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6a1b64d19e11614b0884cc7bc4cf2912",
    "id": null,
    "metadata": {},
    "name": "HomeQuery",
    "operationKind": "query",
    "text": "query HomeQuery {\n  viewer {\n    id\n    unreadBeacons\n    ...BillingIdentityFeaturesPaywall_viewer\n    ...HomePanelGroupsMenu_viewer\n    user {\n      id\n      email\n      isGuest\n      internalAttributes {\n        isManager\n        isAccountAdmin\n        id\n      }\n    }\n    account {\n      allowInviting\n      guestUsersAllowInvite\n      allowExternalInviting\n      billingAccount {\n        hasAccessToTeams: hasAccessToFeature(feature: teams)\n        id\n      }\n      id\n    }\n    myTeams {\n      id\n      archived\n      ...TeamLink_info\n    }\n    homePanelGroups {\n      ...HomePanelGroup_group\n      id\n      __typename\n      type\n      name\n      emojiName\n      order\n      items {\n        edges {\n          node {\n            __typename\n            ... on NoteStream {\n              ...StreamLink_stream\n              id\n              archived\n              starred\n              type\n              otherUser {\n                id\n                email\n              }\n            }\n            ... on Tag {\n              __typename\n              id\n              label\n              color\n            }\n            ... on User {\n              id\n              email\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment BillingIdentityFeaturesPaywall_viewer on Viewer {\n  account {\n    billingAccount {\n      featureAccess\n      id\n    }\n    id\n  }\n}\n\nfragment GroupsMenu_stream on NoteStream {\n  ...HomePanelGroupsMenu_object\n  id\n  homePanelGroup {\n    id\n  }\n}\n\nfragment HomePanelGroup_group on HomePanelGroup {\n  id\n  type\n  name\n  emojiName\n  items {\n    edges {\n      node {\n        __typename\n        ... on User {\n          id\n          ...OneOnOneLink_user\n        }\n        ... on NoteStream {\n          ...StreamLink_stream\n          id\n          archived\n          starred\n          viewerLastSeenAt\n          latestNoteEditedAt\n        }\n        ... on Tag {\n          __typename\n          id\n          label\n          color\n          ...TagLink_tag\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment HomePanelGroupsMenu_object on HomePanelObjectInterface {\n  __isHomePanelObjectInterface: __typename\n  id\n  __typename\n  ... on NoteStream {\n    type\n  }\n  homePanelGroup {\n    id\n    name\n  }\n}\n\nfragment HomePanelGroupsMenu_viewer on Viewer {\n  homePanelGroups {\n    id\n    name\n    type\n    emojiName\n  }\n}\n\nfragment OneOnOneLink_user on User {\n  id\n  fullName\n  image\n  isActive\n  isConfigured\n  email\n  hasReceivedInvites\n  relationshipToViewer\n  isGuest\n  isTopUser\n  activeRecurring1on1Event(onlyReportManager: true) {\n    id\n  }\n}\n\nfragment RecordIcon_event on Event {\n  id\n  guid\n  willBeRecorded\n  start\n  status\n  isAllDay\n  timeBlockType\n  conferenceCalls {\n    provider\n    url\n  }\n  calendar {\n    id\n  }\n}\n\nfragment StreamLink_stream on NoteStream {\n  id\n  type\n  url\n  displayName\n  userCount\n  viewerLastSeenAt\n  latestNoteEditedAt\n  isExternal\n  hasExternalUsers\n  ...GroupsMenu_stream\n  otherUser {\n    ...OneOnOneLink_user\n    id\n  }\n  linkedEvent {\n    id\n    guid\n    nextOccurrence {\n      start\n      end\n      ...RecordIcon_event\n      id\n    }\n    finalOccurrence\n  }\n  latestNote {\n    id\n    eventStart\n    eventEnd\n    finished\n    event {\n      id\n      guid\n      ...RecordIcon_event\n    }\n  }\n  publicLink {\n    enabled\n    id\n  }\n}\n\nfragment TagLink_tag on Tag {\n  id\n  label\n  color\n  homePanelGroup {\n    id\n  }\n  ...HomePanelGroupsMenu_object\n}\n\nfragment TeamLink_info on Team {\n  id\n  title\n  archived\n  url\n}\n"
  }
};
})();

(node as any).hash = "6776752e08200390cc24251f175f97a2";

export default node;
